import React, { useEffect, useRef } from "react";
import { useShownColorScheme } from "hooks/useShownColorScheme";
import { useTranslation } from "react-i18next";
import L from "leaflet";
import appStoreDownloadBadgeSvg from "assets/badges/download_badge_app_store.svg";
import googlePlayDownloadBadgeSvg from "assets/badges/download_badge_google_play.svg";
import "./GPXViewerDownloadDialog.css";

export const GPXViewerDownloadDialog = () => {
  const { t } = useTranslation();
  const colorScheme = useShownColorScheme();
  const elementRef = useRef<HTMLDivElement>(null);

  const openInNewTab = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    if (elementRef.current) {
      L.DomEvent.disableClickPropagation(elementRef.current);
      L.DomEvent.disableScrollPropagation(elementRef.current);
    }
  });

  return (
    <div
      ref={elementRef}
      className="gpx-viewer-download-dialog-outer"
      style={{ backgroundColor: colorScheme === "light" ? "#fff" : "#242424" }}
    >
      <div className="gpx-viewer-download-dialog-inner">
        <p
          className="gpx-viewer-download-dialog-text"
          style={{ color: colorScheme === "light" ? "#000" : "#fff" }}
        >
          {t("gpx_viewer_download_dialog.text")}
        </p>
        <div className="gpx-viewer-download-dialog-badges-row">
          <div
            className="gpx-viewer-download-dialog-google-badge"
            onClick={() =>
              openInNewTab(
                "https://play.google.com/store/apps/details?id=com.vecturagames.android.app.gpxviewer.pro"
              )
            }
          >
            <img src={googlePlayDownloadBadgeSvg} width="100%" height="100%" />
          </div>
          <div
            className="gpx-viewer-download-dialog-apple-badge"
            onClick={() =>
              openInNewTab(
                "https://apps.apple.com/us/app/gpx-viewer-pro/id1497379822"
              )
            }
          >
            <img src={appStoreDownloadBadgeSvg} width="100%" height="100%" />
          </div>
        </div>
      </div>
    </div>
  );
};
